<template>
    <div>
      <div v-if="showBanner" class="banner">
        <span>
          You are in cache bypass mode
          <button class="exit" @click="exitCacheBypass">
            press here to exit
          </button>
          .
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    computed: {
      showBanner() {
        const urlParams = new URLSearchParams(window.location.search);
        const ignoreCache = urlParams.get('ignore_cache');
        return !!ignoreCache
      }
    },
    methods: {
      exitCacheBypass() {
        history.pushState({}, null, location.href.split('?')[0]); 
        window.location.reload(true)
      }
    }
  }
  </script>
  
  <style scoped>
  .banner {
    /* background-color: #c74854; */
    background-color: #e86464;
    text-align: center;
    position: fixed;
    width: 100%;
    height: 30px;
    bottom: 0;
    z-index: 99;
  }
  .exit {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    text-decoration: underline;
  }
  </style>